export const theme = {
   colors: {
      body: '#ffffff',
      white: '#ffffff',
      blue100: '#eef8fb',
      blue200: '#96daf0',
      blue300: '#7cbcde',
      blue400: '#242a3a',
      gray: '#e1e1e1',
      hover: '#00ffff',
      error: '#ff0000',
      overlayColor: 'rgba(0, 0, 0, 0.3)',
   },
   shadow:
      '-1px 4px 74px -16px rgba(0, 0, 0, 0.15)',
   fonts: {
      size100: '14px',
      size200: '16px',
      size300: '18px',
      size400: '24px',
      size500: '32px',
      size600: '36px',

      main: 'Assistant, sans-serif',
      logo: "'Playfair Display', serif",
   },
   widthContainer: '1000px',
   transitions: {
      main: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
   },
};

export const darkTheme = {
   colors: {
      body: '#373744',
      white: '#909090',
      blue100: '#304050',
      blue200: '#96daf0',
      blue300: '#7cbcde',
      blue400: '#242a3a',
      gray: '#e1e1e1',
      hover: '#00ffff',
      error: '#ff0000',
      overlayColor: 'rgba(0, 0, 0, 0.3)',
   },
   shadow:
      '-1px 4px 74px -16px rgba(0, 0, 0, 0.15)',
   fonts: {
      size100: '14px',
      size200: '16px',
      size300: '18px',
      size400: '24px',
      size500: '32px',
      size600: '36px',

      main: 'Assistant, sans-serif',
      logo: "'Playfair Display', serif",
   },
   widthContainer: '1000px',
   transitions: {
      main: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
   },
};
